import React, { useEffect, useState } from "react";
import backArrow from "../../assets/images/back-arrow.png";
import queryString from "query-string";
import analytics from "../../util/analytics";
import Toaster from "../../components/Toaster";
import SolarSteps from "../../components/SolarSteps";
import TopBar from "../../components/multi-step-components/TopBar";
import "../multi-step-form/styles.scss";
import LoadingTopBar from "../../components/LoadingTopBar";

const SolarFunnel = ({ location: { search }, mediaQuery, match: { path } }) => {
  const [userAddress, setUserAddress] = useState("");
  const [refCode, setRefCode] = useState("");

  const [formStep, setFormStep] = useState(false);
  // const [showWelcomeToast, setShowWelcomeToast] = useState(true);

  useEffect(() => {
    analytics.page({
      page: "Solar Funnel",
    });
  }, []);

  useEffect(() => {
    if (search) {
      const parsedQueryString = queryString.parse(search);
      const { address, ref } = parsedQueryString;

      setUserAddress(decodeURI(address));

      ref && setRefCode(ref);

      address && address?.trim() && setFormStep(1);

      !address?.trim() && setFormStep(0);
    } else {
      setFormStep(0);
    }
  }, [search]);

  return (
    <>
      <>
        {formStep <= 5 ? (
          <TopBar roofType={"solar"} mediaQuery={mediaQuery} step={formStep} />
        ) : (
          <LoadingTopBar />
        )}

        <SolarSteps
          step={formStep}
          setStep={setFormStep}
          userAddress={userAddress}
          parsedQueryString={queryString.parse(search)}
          refCode={refCode}
        />

        {/* {formStep === 1 && (
          <Toaster
            showToast={showWelcomeToast}
            setShowToast={setShowWelcomeToast}
          />
        )} */}
        {formStep > 0 && formStep < 6 && (
          <span
            onClick={() => setFormStep(formStep - 1)}
            className="go-back-section"
          >
            <img src={backArrow} alt="Go Back Icon" className="back-arrow" />{" "}
            Back
          </span>
        )}
      </>
    </>
  );
};

export default SolarFunnel;
